var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"flat":"","color":"green"},on:{"click":_vm.openDashboard}},[_vm._v("View")])
}
var staticRenderFns = []

export { render, staticRenderFns }